export class FacebookCallbackController {
    static $inject = ['$cookies', '$window', '$timeout', 'BLIP_DOMAIN'];
    constructor($cookies, $window, $timeout, BLIP_DOMAIN) {
        'ngInject';
        this.$cookies = $cookies;
        this.$window = $window;
        this.$timeout = $timeout;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.$onInit();
    }
    $onInit() {
        const params = this.processUrl(window.location.href);
        this.saveFacebookResponseOnCookie(params);
    }
    processUrl(url) {
        const paramStrings = url.split(/#|\?/)[1].split('&');
        return paramStrings.reduce((params, text) => {
            const param = text.split('=')[0];
            const value = text.split('=')[1];
            params[param] = value;
            return params;
        }, {});
    }
    saveFacebookResponseOnCookie({ access_token, code, state }) {
        const cookieObject = {
            accessToken: access_token,
            code,
            state,
        };
        const ONE_MINUTE = 60000;
        const now = new Date().getTime();
        const nowPlusOneMinuteDate = new Date(now + ONE_MINUTE);
        this.$cookies.putObject(state, cookieObject, { expires: nowPlusOneMinuteDate });
        // this cookie is setting to the root domain, for those looking in subdomain can find it
        // note: we choose to call twice because if the domain was not valid the cookie is not saved
        this.$cookies.putObject(state, cookieObject, {
            expires: nowPlusOneMinuteDate,
            domain: this.BLIP_DOMAIN,
        });
        // this timeout prevent a memory leak that happen after closing the window after fb login on popup
        this.$timeout(() => {
            this.$window.close();
        }, 500);
    }
}
FacebookCallbackController.$inject = ['$cookies', '$window', '$timeout', 'BLIP_DOMAIN'];
